export default __webpack_public_path__ + "static/media/icon_weblink_red.91f563c4.svg";